import React from "react";

export default function WirelessIcon(props: any) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="80"
      height="80"
      viewBox="0 0 80 80"
    >
      <defs>
        <path id="9vmgkp42ma" d="M0.627 0.917L12 0.917 12 49 0.627 49z" />
        <path id="o1ylhbv3dc" d="M0 0.917L11.373 0.917 11.373 49 0 49z" />
        <path id="gxzzqmu74e" d="M0 63.084L68 63.084 68 1 0 1z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <g transform="translate(-1380 -2418) translate(1281 2398) translate(76 20) translate(23) translate(6 8)">
                  <path
                    fill="#231F20"
                    d="M34 15.041c-2.56 0-5.118.977-7.071 2.93-3.906 3.904-3.906 10.236 0 14.141 1.953 1.953 4.511 2.93 7.071 2.93 2.56 0 5.118-.977 7.071-2.93 3.906-3.905 3.906-10.237 0-14.142-1.953-1.951-4.511-2.928-7.071-2.928m0 2c2.137 0 4.146.831 5.657 2.342C41.168 20.895 42 22.904 42 25.041s-.832 4.146-2.343 5.657c-1.511 1.511-3.52 2.343-5.657 2.343s-4.146-.831-5.657-2.342C26.832 29.186 26 27.178 26 25.04c0-2.137.832-4.146 2.343-5.657 1.511-1.51 3.52-2.343 5.657-2.343"
                  />
                  <g transform="translate(56 .084)">
                    <mask id="ir081owxnb" fill="#fff">
                      <use xlinkHref="#9vmgkp42ma" />
                    </mask>
                    <path
                      fill="#231F20"
                      d="M.627 47.585L2.042 49c13.277-13.279 13.277-34.806 0-48.084L.627 2.33c12.478 12.477 12.478 32.778 0 45.255"
                      mask="url(#ir081owxnb)"
                    />
                  </g>
                  <g transform="translate(0 .084)">
                    <mask id="qt9c25zo5d" fill="#fff">
                      <use xlinkHref="#o1ylhbv3dc" />
                    </mask>
                    <path
                      fill="#231F20"
                      d="M11.373 2.33L9.958.918C-3.319 14.195-3.319 35.722 9.958 49l1.415-1.414c-12.478-12.477-12.478-32.778 0-45.255"
                      mask="url(#qt9c25zo5d)"
                    />
                  </g>
                  <path
                    fill="#231F20"
                    d="M15.615 6.657l-1.414-1.414c-10.935 10.935-10.935 28.663 0 39.598l1.414-1.414c-10.138-10.138-10.138-26.632 0-36.77M52.385 43.426l1.414 1.415c10.935-10.936 10.935-28.664 0-39.599l-1.414 1.414c10.138 10.138 10.138 26.633 0 36.77"
                  />
                  <path
                    fill="#231F20"
                    d="M19.857 10.9l-1.414-1.415c-8.59 8.591-8.59 22.521 0 31.113l1.414-1.415c-7.798-7.798-7.798-20.486 0-28.284M48.143 39.184l1.414 1.415c8.59-8.592 8.59-22.522 0-31.113L48.143 10.9c7.798 7.798 7.798 20.486 0 28.284"
                  />
                  <path
                    fill="#231F20"
                    d="M43.9 34.94l1.413 1.416c6.25-6.25 6.25-16.38 0-22.628L43.9 15.142c5.46 5.459 5.46 14.34 0 19.799M24.1 15.142l-1.413-1.414c-6.25 6.248-6.25 16.38 0 22.627l1.414-1.414c-5.46-5.459-5.46-14.34 0-19.799"
                  />
                  <path fill="#FEFEFE" d="M34 35.084L34 63.084" />
                  <mask id="m014069ckf" fill="#fff">
                    <use xlinkHref="#gxzzqmu74e" />
                  </mask>
                  <path
                    fill="#231F20"
                    d="M33 63.084L35 63.084 35 35.084 33 35.084z"
                    mask="url(#m014069ckf)"
                  />
                  <path
                    fill="#FEFEFE"
                    d="M41 62.084L27 62.084"
                    mask="url(#m014069ckf)"
                  />
                  <path
                    fill="#231F20"
                    d="M27 63.084L41 63.084 41 61.084 27 61.084z"
                    mask="url(#m014069ckf)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
